import { Check } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { LANDING_COPY, SUBSCRIBE_HREF } from "@/data/landingContent";
import { formatProMonthlyPrice, PRO_FEATURES } from "@/lib/pricing";
import { PrimaryCta } from "./LandingShared";

export const PricingSection = () => {
  const reduce = useReducedMotion();

  return (
    <section id="preco" className="container mx-auto scroll-mt-24 px-5 py-20 md:px-8">
      <motion.div
        className="mx-auto max-w-2xl text-center"
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.5 }}
      >
        <p className="text-overline uppercase text-neutral-500">
          {LANDING_COPY.pricingEyebrow}
        </p>
        <h2 className="mt-3 text-h1 md:text-display">
          {LANDING_COPY.pricingTitle}
        </h2>
        <p className="mt-3 text-body text-neutral-500">{LANDING_COPY.pricingSub}</p>
      </motion.div>

      <motion.article
        className="landing-card mx-auto mt-12 max-w-lg rounded-[28px] border-2 border-blue-500 bg-white px-6 py-8 md:px-8"
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.45 }}
      >
        <p className="text-center text-overline uppercase text-blue-600">
          {LANDING_COPY.pricingName}
        </p>
        <p className="mt-3 text-center text-display text-neutral-900">
          {formatProMonthlyPrice()}
          <span className="text-body text-neutral-500">{LANDING_COPY.pricingPeriod}</span>
        </p>
        <ul className="mt-8 space-y-3">
          {PRO_FEATURES.map((feature) => (
            <li key={feature} className="flex items-center gap-2.5 text-body text-neutral-900">
              <Check className="h-4 w-4 shrink-0 text-blue-500" />
              {feature}
            </li>
          ))}
        </ul>
        <div className="mt-8">
          <PrimaryCta fullWidth href={SUBSCRIBE_HREF} label={LANDING_COPY.closeCta} />
        </div>
      </motion.article>

      <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-body-sm text-neutral-500">
        {LANDING_COPY.pricingTrust.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
};
